/**
 * 埋点常量定义
 * 新增埋点类型：在 TRACKING_TYPES 中添加
 */

export const TRACKING_TYPES = {
  /** 首页访问 */
  HOME_PAGE_VISIT: 'home_page_visit',
  /** 首页跳出（访问首页后未访问其他页面直接离开） */
  HOME_PAGE_BOUNCE: 'home_page_bounce',
  /** 注册页访问 */
  REGISTER_PAGE_VISIT: 'register_page_visit',
  /** 注册成功 */
  REGISTER_SUCCESS: 'register_success',
  /** 后台访问 */
  BACKEND_PAGE_VISIT: 'backend_page_visit',
} as const

export type TrackingType = (typeof TRACKING_TYPES)[keyof typeof TRACKING_TYPES]
